/**
 * Tooltip functunality
 * @module tooltip
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';

export const PLUGIN_NAME = 'tooltip';

export const DEFAULTS = {

};

/**
 * Sends focus to the content container.
 * @param  {jQuery} $el - button /element that toggles text
 */
const scrollToView = ($el) => {
  const tooltipContent = $el.attr('href');
  $(tooltipContent).focus();
};
/**
 * Prevents default functunality on click
 * @param  {jQuery} $el - button /element that toggles text
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const setEventListeners = ($el, {}) => {
  $el.on('click', (evt) => {
    evt.preventDefault();
    scrollToView($el);
  });
};
/**
 * Initializes Header.
 * @param {HTMLElement} el - trigger
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
export default function tooltip(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  setEventListeners($el, opts);
}
registerJQueryPlugin(PLUGIN_NAME, tooltip);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/tooltip.js